export default __webpack_public_path__ + "static/media/feature_vindbeggeveje.5aad7f6f.jpg";